import { useMutation, useQuery } from "@apollo/client";
import React, { useEffect, useRef, useState, useContext } from "react";
import { useParams, useNavigate } from "react-router";
import LoadingBar from "react-top-loading-bar";
import { toastError, toastWarning } from "../../../../shared/helpers";
import { UPDATE_REFERRAL_FORM } from "../../../../shared/queries";

import { demoContext } from "../../../../shared/store/contexts";
import PageHero from "../../../molecules/PageHero";
import CreateReferralFormSuccessModal from "../../../organisms/CreateReferralFormSuccessModal";
import ReferralCopyCodeModal from "../../../organisms/ReferralCopyCodeModal";
import ReferralFormShareLinkModal from "../../../organisms/ReferralFormShareLinkModal";
import { FormOne, FormPreview, FormTwo } from "../../../templates/AddReferralForms";

const EditReferralFormPage = () => {
  const { id, formId } = useParams();
  let navigate = useNavigate();

  const loader = useRef(null);

  const { referralForms } = useContext(demoContext);

  const [step, setStep] = useState(1);
  const [fields, setFields] = useState({});
  const [formInfo, setFormInfo] = useState({});

  useEffect(() => {
    if (referralForms) {
      setFields({
        ...fields,
        formFields: JSON.parse(referralForms[0]?.formFields),
        service: {
          value: referralForms[0].service?.id,
          label: referralForms[0].service?.name,
        },
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [referralForms]);

  const [modalStates, setModalStates] = useState({
    shareLink: false,
    copyCode: false,
    createFormSuccess: false,
  });

  const updateFields = (data) => setFields({ ...fields, ...data });

  const discardData = () => {
    navigate(`/dashboard/organization/${id}/referral-forms`);
  };

  const [editReferralForm] = useMutation(UPDATE_REFERRAL_FORM);

  const onSubmit = (mode = "publish") => {
    if (loader) {
      loader.current.continuousStart();
    }

    const { formFields } = fields;

    toastWarning("Can not perform this action on demo mode");
  };

  return (
    <main className="flex flex-col w-full relative">
      <LoadingBar height={2} color="#00AF72" ref={loader} />
      <PageHero
        className="organization-container"
        title="Add Custom Referral Form"
        description="Back to  Referrals"
      />

      <>
        {step === 1 && (
          <FormOne
            fields={fields}
            updateFields={updateFields}
            discard={discardData}
            saveToDraft={(data) => onSubmit(data, "draft")}
            changeStep={(step) => setStep(step)}
          />
        )}
        {step === 2 && (
          <FormTwo
            fields={fields}
            updateFields={updateFields}
            discard={discardData}
            saveToDraft={(data) => onSubmit(data, "draft")}
            changeStep={(step) => setStep(step)}
          />
        )}
        {step === 3 && (
          <FormPreview
            fields={fields}
            updateFields={updateFields}
            discard={discardData}
            saveToDraft={(data) => onSubmit(data, "draft")}
            changeStep={(step) => setStep(step)}
            submitForm={() => onSubmit("publish")}
          />
        )}
        {modalStates?.createFormSuccess && (
          <CreateReferralFormSuccessModal
            closeModal={() => {
              window.location = `/dashboard/organization/${id}/referral-forms/`;
            }}
            showShareLinkModal={() => {
              setModalStates({ ...modalStates, shareLink: true });
            }}
            showCodeModal={() => {
              setModalStates({ ...modalStates, copyCode: true });
            }}
          />
        )}
        {modalStates?.shareLink && (
          <ReferralFormShareLinkModal
            closeModal={() => setModalStates({ ...modalStates, shareLink: false })}
            link={formInfo?.url}
          />
        )}
        {modalStates?.copyCode && (
          <ReferralCopyCodeModal
            closeModal={() => setModalStates({ ...modalStates, copyCode: false })}
            link={formInfo?.url}
          />
        )}
      </>
    </main>
  );
};

export default EditReferralFormPage;
